import { useState } from 'react';
import { randomId } from '@linktivity/link-utils';

export function useRandomId(staticId?: string) {
  const [id] = useState(() => randomId());

  return staticId || id;
}
